// this is a light-weight build without the scrolling module
module.exports = require("./src/index.js");



//////////////////
// WEBPACK FOOTER
// ./~/biojs-vis-seqlogo/light.js
// module id = 97
// module chunks = 0